module.exports = __webpack_public_path__ + "static/media/icon-menu-profilim.01537216.svg";